import {
  SET_SOFT_COLLECT_LIST,
  SET_COLLECT_LOADING,
  SET_SPECIAL_COLLECT_LIST,
  UPDATE_SPECIAL_COLLECT_LIST,
  UPDATE_SOFT_COLLECT_LIST,
} from '../constants/collection';

const initState = {
  collectSoftList: {
    list: [],
    pagenation: {},
    error: false,
  },
  collectSpecialList: {
    list: [],
    pagenation: {},
    error: false,
  },
  loading: false,
};

const collection = (state = initState, action = {}) => {
  switch (action.type) {
    case SET_SOFT_COLLECT_LIST:
      // eslint-disable-next-line no-case-declarations
      let tempList = state.collectSoftList.list; // 计算收藏列表定义临时变量
      // eslint-disable-next-line no-case-declarations
      const { error, list, code, refresh, limit } = action.payload;
      // eslint-disable-next-line no-case-declarations
      let totalCount;
      if (!error && code === 0) {
        // 正常有数据
        tempList = !refresh ? [...state.collectSoftList.list, ...list] : list;
        totalCount = ((tempList && tempList.length) || 0) + (list && list.length < limit ? 0 : 1);
      }

      if (!error && code === 200500) {
        tempList = !refresh ? [...state.collectSoftList.list, ...list] : list;
        totalCount = (tempList && tempList.length) || 0;
      }
      return {
        ...state,
        collectSoftList: {
          ...state.collectSoftList,
          error,
          list: tempList,
          pagenation: {
            count: totalCount,
          },
        },
      };
    case SET_SPECIAL_COLLECT_LIST:
      // eslint-disable-next-line no-case-declarations
      let tempLists = state.collectSpecialList.list; // 计算收藏列表定义临时变量
      // eslint-disable-next-line no-case-declarations
      const {
        error: errors,
        list: lists,
        code: codes,
        refresh: refreshs,
        limit: limits,
      } = action.payload;
      // eslint-disable-next-line no-case-declarations
      let totalCounts;
      if (!errors && codes === 0) {
        // 正常有数据
        tempLists = !refreshs ? [...state.collectSpecialList.list, ...lists] : lists;
        totalCounts =
          ((tempLists && tempLists.length) || 0) + (lists && lists.length < limits ? 0 : 1);
      }

      if (!errors && codes === 200500) {
        tempLists = !refreshs ? [...state.collectSpecialList.list, ...lists] : lists;
        totalCounts = (tempLists && tempLists.length) || 0;
      }

      return {
        ...state,
        collectSpecialList: {
          ...state.collectSpecialList,
          errors,
          list: tempLists,
          pagenation: {
            count: totalCounts,
          },
        },
      };
    case UPDATE_SPECIAL_COLLECT_LIST:
      return {
        ...state,
        collectSpecialList: {
          ...state.collectSpecialList,
          list: state.collectSpecialList.list.filter(item => item.ztId !== action.payload.targetId),
          pagenation: {
            ...state.collectSpecialList.pagenation,
            count: state.collectSpecialList.pagenation.count - 1,
          },
        },
      };
    case UPDATE_SOFT_COLLECT_LIST:
      return {
        ...state,
        collectSoftList: {
          ...state.collectSoftList,
          list: state.collectSoftList.list.filter(item => {
            if (action.payload.targetType === 'pc') {
              return (item.softID || item.softId) !== action.payload.targetId;
            }
            return item.packageName !== action.payload.targetId;
          }),
          pagenation: {
            ...state.collectSoftList.pagenation,
            count: state.collectSoftList.pagenation.count - 1,
          },
        },
      };
    case SET_COLLECT_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state;
  }
};

export default collection;
